import React, { Component, PropsWithChildren } from 'react';
import { StatusInfoErrorBoundary } from '../StatusInfo';
import { windowLogger } from '../../Logger/windowLogger';

export class ErrorBoundary extends Component<PropsWithChildren, { hasError: boolean }> {
  constructor(props: PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  // Update state so the next render will show the fallback UI.
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, info: any) {
    windowLogger.error(error, info.componentStack);
  }

  render() {
    return this.state.hasError ? <StatusInfoErrorBoundary /> : this.props.children;
  }
}
